import { ChangeDetectionStrategy, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SortOrderBy, SortDefinition } from '../../models';
import { DataSortComponent } from '../data-sort';

@Component({
  selector: 'app-header-data-sort',
  templateUrl: './header-data-sort.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderDataSortComponent extends DataSortComponent implements OnInit, OnChanges {
  constructor(router: Router, translate: TranslateService) {
    super(router, translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  isSortable(sortDefinition: SortDefinition<any>): boolean {
    return !!(sortDefinition.propertySelector || sortDefinition.sortFunc);
  }

  isCaretShown(sortId: string): boolean {
    return sortId === this.selectedItem.id;
  }

  isCaretRotated(sortId: string): boolean {
    return this.isCaretShown(sortId) && (this.selectedOrderBy === SortOrderBy.DESC);
  }

  selectHeaderSort(sort: SortDefinition<any>): void {
    if (!this.isSortable(sort) || (sort.allowOnlyOneDirection && this.selectedItem === sort)) {
      return;
    }

    if (this.selectedItem === sort) {
      this.changeDirection();
    } else {
      this.selectedOrderBy = SortOrderBy.ASC;
      this.selectSort(sort);
    }
  }
}
